module.exports = __webpack_public_path__ + "static/img/15.ce779ae3.png";